/** Consistent color palette for the 9 activities. Used by charts and legend pills. */
export const ACTIVITY_COLORS: Record<string, string> = {
  memory:       '#4DA167',
  wordmatch:    '#E07A5F',
  cutlery:      '#3D9FD4',
  wordsearch:   '#9B5DE5',
  sudoku:       '#F4A261',
  maths:        '#2EC4B6',
  shoppinglist: '#E75480',
  eurmoney:     '#8AC926',
  pillbox:      '#FF6B6B',
}

/** Consistent color palette for the 7 game categories. */
export const CATEGORY_COLORS: Record<string, string> = {
  memory:           '#4DA167',
  language:         '#9B5DE5',
  'daily-life':     '#3D9FD4',
  logic:            '#F4A261',
  maths:            '#2EC4B6',
  attention:        '#E07A5F',
  'visual-spatial': '#E75480',
}

export const ACTIVITY_COLOR_DEFAULT = '#888888'
